import * as React from 'react';
import { useSelector } from 'react-redux';

import { CPDLink } from './CPDLink';
import { trackCpdLandingLinkClick } from './tracking';
import { selectCpdAvailable } from '../../reducers/cpd/selectCpdAvailable';
import { selectCpdLandingUrl } from '../../reducers/cpd/selectCpdLandingUrl';

export const CPDDesktopContainer: React.FC = () => {
  const isAvailable = useSelector(selectCpdAvailable);
  const landingUrl = useSelector(selectCpdLandingUrl);

  const handleClick = React.useCallback(() => {
    trackCpdLandingLinkClick();
  }, []);

  if (!isAvailable || !landingUrl) {
    return null;
  }

  return (
    <CPDLink onClick={handleClick} url={landingUrl}>
      <span>Сделка</span>
    </CPDLink>
  );
};
